<template>
  <a-drawer placement="right" :closable="true" :visible="hidden" :width="1100" :destroyOnClose="true"
    :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
    <div class="drawer-box" style="width:100%;height:100%">
      <div class="section-title" style="margin:1.4em 0">基础信息</div>
      <a-descriptions style="margin: 0 2em;">
        <a-descriptions-item label="配方名称">{{ detailInfo.formulaName }}</a-descriptions-item>
        <a-descriptions-item label="配方代码">{{ detailInfo.formulaCode }}</a-descriptions-item>
        <a-descriptions-item label="动物类型">{{ detailInfo.animalTypeName }}</a-descriptions-item>
        <a-descriptions-item label="配方类型">{{ ['', '配合饲料', '混合日粮', 'TMR', '定制料'][detailInfo.formulaType]
          }}</a-descriptions-item>
      </a-descriptions>

      <div class="section-title">配方详情</div>
      <a-tabs :default-active-key="activeTabKey" @change="tabChange">
        <a-tab-pane tab="配方原料" key="1">
          <a-table :columns="tableColumns_1" :loading="tableLoading" :data-source="tableData_1"
            :row-key="(record) => record.id" bordered :pagination="false" :scroll="{ y: 500 }">

            <template slot="minValueTitle">
              <div>最小值</div>
              <div style="font-size: 10px;color: #999;">现行配方/多配方系统</div>
            </template>
            <template slot="minValue" slot-scope="text,record">
              <span v-if="record.minValueFormula !== null || record.minValue !== null">
                {{ record.minValueFormula }}/{{ record.minValue }}
                (<font :style="{ color: record.minValueFormulaDiff_color }">{{
                  record.minValueFormulaDiff_arrow
                  }}{{ record.minValueFormulaDiff_text }}</font>)
              </span>
            </template>
            <template slot="maxValueTitle">
              <div>最大值</div>
              <div style="font-size: 10px;color : #999;">现行配方/多配方系统</div>
            </template>
            <template slot="maxValue" slot-scope="text,record">
              <span v-if="record.maxValueFormula !== null || record.maxValue !== null">
                {{ record.maxValueFormula }}/{{ record.maxValue }}
                (<font :style="{ color: record.maxValueFormulaDiff_color }">{{
                  record.maxValueFormulaDiff_arrow
                  }}{{ record.maxValueFormulaDiff_text }}</font>)
              </span>
            </template>
            <template slot="minLimitValueTitle">
              <div>极下限</div>
              <div style="font-size: 10px;color: #999;">现行配方/多配方系统</div>
            </template>
            <template slot="minLimitValue" slot-scope="text,record">
              <span v-if="record.minLimitValueFormula !== null || record.minLimitValue !== null">
                {{ record.minLimitValueFormula }}/{{ record.minLimitValue }}
                (<font :style="{ color: record.minLimitValueFormulaDiff_color }">{{
                  record.minLimitValueFormulaDiff_arrow
                  }}{{ record.minLimitValueFormulaDiff_text }}</font>)
              </span>
            </template>
            <template slot="maxLimitValueTitle">
              <div>极上限</div>
              <div style="font-size: 10px;color: #999;">现行配方/多配方系统</div>
            </template>
            <template slot="maxLimitValue" slot-scope="text,record">
              <span v-if="record.maxLimitValueFormula !== null || record.maxLimitValue !== null">
                {{ record.maxLimitValueFormula }}/{{ record.maxLimitValue }}
                (<font :style="{ color: record.maxLimitValueFormulaDiff_color }">{{
                  record.maxLimitValueFormulaDiff_arrow
                  }}{{ record.maxLimitValueFormulaDiff_text }}</font>)
              </span>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="配方营养需要量" key="2">
          <a-table :columns="tableColumns_2" :loading="tableLoading" :data-source="tableData_2"
            :row-key="(record) => record.id" bordered :pagination="false" :scroll="{ y: 500 }">

            <template slot="minValueTitle">
              <div>最小值</div>
              <div style="font-size: 10px;color: #999;">现行配方/多配方系统</div>
            </template>
            <template slot="minValue" slot-scope="text,record">
              <span v-if="record.minValueFormula !== null || record.minValue !== null">
                {{ record.minValueFormula }}/{{ record.minValue }}
                (<font :style="{ color: record.minValueFormulaDiff_color }">{{
                  record.minValueFormulaDiff_arrow
                  }}{{ record.minValueFormulaDiff_text }}</font>)
              </span>
            </template>
            <template slot="maxValueTitle">
              <div>最大值</div>
              <div style="font-size: 10px;color : #999;">现行配方/多配方系统</div>
            </template>
            <template slot="maxValue" slot-scope="text,record">
              <span v-if="record.maxValueFormula !== null || record.maxValue !== null">
                {{ record.maxValueFormula }}/{{ record.maxValue }}
                (<font :style="{ color: record.maxValueFormulaDiff_color }">{{
                  record.maxValueFormulaDiff_arrow
                  }}{{ record.maxValueFormulaDiff_text }}</font>)
              </span>
            </template>
            <template slot="minLimitValueTitle">
              <div>极下限</div>
              <div style="font-size: 10px;color: #999;">现行配方/多配方系统</div>
            </template>
            <template slot="minLimitValue" slot-scope="text,record">
              <span v-if="record.minLimitValueFormula !== null || record.minLimitValue !== null">
                {{ record.minLimitValueFormula }}/{{ record.minLimitValue }}
                (<font :style="{ color: record.minLimitValueFormulaDiff_color }">{{
                  record.minLimitValueFormulaDiff_arrow
                  }}{{ record.minLimitValueFormulaDiff_text }}</font>)
              </span>
            </template>
            <template slot="maxLimitValueTitle">
              <div>极上限</div>
              <div style="font-size: 10px;color: #999;">现行配方/多配方系统</div>
            </template>
            <template slot="maxLimitValue" slot-scope="text,record">
              <span v-if="record.maxLimitValueFormula !== null || record.maxLimitValue !== null">
                {{ record.maxLimitValueFormula }}/{{ record.maxLimitValue }}
                (<font :style="{ color: record.maxLimitValueFormulaDiff_color }">{{
                  record.maxLimitValueFormulaDiff_arrow
                  }}{{ record.maxLimitValueFormulaDiff_text }}</font>)
              </span>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>

    <template #title>
      <a-page-header style="padding: 0;" title="查看配方" sub-title="多配方系统优化后的配方模型" />
    </template>
  </a-drawer>
</template>

<script>
import { nhfMixins } from '../../untils';

const tableColumns_1 = [
  {
    title: "原料名称",
    align: 'center',
    dataIndex: "rawName",
    width: 140,
    ellipsis: true,
  },
  {
    title: "原料代码",
    align: 'center',
    dataIndex: "rawCode",
    width: 140,
    ellipsis: true,
  },
  {
    title: "用量(%)",
    align: 'center',
    dataIndex: "multiPercentage",
    width: 140,
    ellipsis: true,
  },
  {
    dataIndex: "minValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'minValueTitle' },
    scopedSlots: { customRender: 'minValue' },
  },
  {
    dataIndex: "maxValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'maxValueTitle' },
    scopedSlots: { customRender: 'maxValue' },
  },
  {
    dataIndex: "minLimitValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'minLimitValueTitle' },
    scopedSlots: { customRender: 'minLimitValue' },
  },
  {
    dataIndex: "maxLimitValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'maxLimitValueTitle' },
    scopedSlots: { customRender: 'maxLimitValue' },
  },
];
const tableColumns_2 = [
  {
    title: "指标名称",
    align: 'center',
    dataIndex: "nutritionName",
    width: 140,
    ellipsis: true,
  },
  {
    title: "数值",
    align: 'center',
    dataIndex: "content",
    width: 140,
    ellipsis: true,
  },
  {
    title: "单位",
    align: 'center',
    dataIndex: "unit",
    width: 140,
    ellipsis: true,
  },
  {
    dataIndex: "minValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'minValueTitle' },
    scopedSlots: { customRender: 'minValue' },
  },
  {
    dataIndex: "maxValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'maxValueTitle' },
    scopedSlots: { customRender: 'maxValue' },
  },
  {
    dataIndex: "minLimitValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'minLimitValueTitle' },
    scopedSlots: { customRender: 'minLimitValue' },
  },
  {
    dataIndex: "maxLimitValue",
    align: 'center',
    width: 140,
    ellipsis: true,
    slots: { title: 'maxLimitValueTitle' },
    scopedSlots: { customRender: 'maxLimitValue' },
  },
];

export default {
  props: {
    hidden: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => { }
    }
  },
  mixins: [nhfMixins],
  data() {
    return {
      result: {},
      analyseLoading: false,
      containerHeight: 500,
      wrapStyle: {
        overflow: 'hidden'
      },
      bodyStyle: {
        overflow: 'hidden',
      },
      activeTabKey: 1,
      tableLoading: false,
      tableColumns_1,
      tableData_1: [],
      tableColumns_2,
      tableData_2: []
    };
  },
  watch: {
    hidden(val) {
      if (val) {
        this.tabChange(this.activeTabKey);
      }
    }
  },
  methods: {
    dataProcess(arr) {
      const temp_array = ['minValueFormulaDiff', 'maxValueFormulaDiff', 'minLimitValueFormulaDiff', 'maxLimitValueFormulaDiff'];
      const temp_array_2 = ['minValue', 'minValueFormula', 'maxValue', 'maxValueFormula', 'minLimitValue', 'minLimitValueFormula', 'maxLimitValue', 'maxLimitValueFormula', 'multiPercentage'];
      const digitCount = this.activeTabKey == 1 ? 3 : 2;
      arr.forEach(item => {
        temp_array.forEach(key => {
          const key_value = item[key];
          if (key_value !== null) {
            item[key + '_text'] = Math.abs(key_value).toFixed(digitCount);
          }

          if (key_value > 0) {
            item[key + '_arrow'] = '↑';
            item[key + '_color'] = 'red';
          }
          if (key_value < 0) {
            item[key + '_arrow'] = '↓';
            item[key + '_color'] = 'green';
          }
          if (key_value == 0) {
            item[key + '_text'] = '-';
          }
        });

        temp_array_2.forEach(key => {
          const key_value = item[key];
          if (key_value !== null) {
            item[key] = Math.abs(key_value).toFixed(digitCount);
          }
        });

        if (item.content) {
          if (item.unit == 'MJ' || item.unit == 'Kcal') {
            item.content = item.content.toFixed(0);
          } else {
            item.content = item.content.toFixed(2);
          }
        }
      });
    },
    onClose() {
      this.activeTabKey = 1;
      this.$emit('close');
    },

    tabChange(key) {
      this.activeTabKey = key;
      this.tableData_1 = [];
      this.tableData_2 = [];
      const data = {
        formulaId: this.detailInfo.formulaId,
        pushTaskId: this.detailInfo.id
      };
      const actionName = ['', 'pushFormulaRecordRaw', 'pushFormulaRecordNutritionAll'][key];
      this.fetchGet({
        actions: this[actionName],
        data,
        name: `tableData_${key}`,
        loading: "tableLoading"
      }).then(res => {
        if (res.success) {
          this.dataProcess(res.data);
          this[`tableData_${key}`] = [].concat(res.data);
        }
      });
    },
  }
};
</script>


<style lang="scss" scoped>
.section-title {
  color: #333;
  font-weight: bold;
}

.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.containers {
  width: 100%;
  flex: 1;
  height: calc(100vh - 100px);
}

::v-deep .drawer {
  overflow: hidden;

  .ant-drawer-wrapper-body,
  .ant-drawer-wrapper-body {
    overflow: hidden;
  }
}
</style>
